/**
 * mountEscapeButton — mounts a fixed ✕ 離開 button on the page.
 * Returns an unmount function that removes the button.
 * The button prompts for confirmation before calling onConfirm.
 */
export function mountEscapeButton(onConfirm: () => void): () => void {
  const btn = document.createElement('button');
  btn.className = 'escape-btn';
  btn.textContent = '✕ 離開';
  btn.addEventListener('click', () => {
    if (confirm('真的要離開嗎? 修煉值不會儲存')) {
      onConfirm();
    }
  });
  document.body.appendChild(btn);
  return () => btn.remove();
}
